import { render, staticRenderFns } from "./ManageCategoryPage.vue?vue&type=template&id=2b851b8b&scoped=true&"
import script from "./ManageCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ManageCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b851b8b",
  null
  
)

export default component.exports